var exports = {
  "TN": "MemberListSkeleton.module__groups___MkhBNl",
  "Os": "MemberListSkeleton.module__group___MkhBNl",
  "Ge": "MemberListSkeleton.module__rows___MkhBNl",
  "x_": "MemberListSkeleton.module__groupHeader___MkhBNl",
  "nM": "MemberListSkeleton.module__row___MkhBNl",
  "u4": "MemberListSkeleton.module__rowContent___MkhBNl",
  "z2": "MemberListSkeleton.module__rowInfo___MkhBNl",
  "U8": "MemberListSkeleton.module__nameSlot___MkhBNl",
  "NJ": "MemberListSkeleton.module__statusSlot___MkhBNl",
};

module.exports = exports;
